export default __webpack_public_path__ + "static/icon-benefits-home-caixa-817f19168a2c051c3b5aea9426d98202.png";